import MntnGlobalPixel from './MntnGlobalPixel';

export default MntnGlobalPixel;
